import { render, staticRenderFns } from "./GiftCardButton.vue?vue&type=template&id=26716b97&scoped=true"
import script from "./GiftCardButton.vue?vue&type=script&lang=js"
export * from "./GiftCardButton.vue?vue&type=script&lang=js"
import style0 from "./GiftCardButton.vue?vue&type=style&index=0&id=26716b97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26716b97",
  null
  
)

export default component.exports